import { GOOGLE_PARTNER_FORM } from '@env';

/**
 * Google Forms URL segment after `/d/e/` (not the full URL).
 *
 * Local: set `GOOGLE_PARTNER_FORM` in `frontend/.env` (react-native-dotenv inlines at build).
 *
 * Cloudflare Pages: set the variable for the **build** (and the environment you deploy
 * from). Workers-only **Secrets** are not injected into the Node process that runs
 * `expo export` / webpack, so the client bundle will get `undefined` unless the same name
 * exists as a Pages **Environment variable** (Build + Production).
 *
 * `@env` (react-native-dotenv) only reads a local `.env` file, so on CI the value comes
 * from `process.env` instead: `EXPO_PUBLIC_GOOGLE_PARTNER_FORM` (inlined by Expo) or the
 * plain `GOOGLE_PARTNER_FORM` (inlined by webpack DefinePlugin, see `webpack.config.js`).
 */
export function getGooglePartnerFormId(): string {
  const fromDotenv =
    typeof GOOGLE_PARTNER_FORM === 'string' ? GOOGLE_PARTNER_FORM.trim() : '';
  if (fromDotenv && fromDotenv !== 'undefined') {
    return fromDotenv;
  }
  const fromExpo =
    typeof process.env.EXPO_PUBLIC_GOOGLE_PARTNER_FORM === 'string'
      ? process.env.EXPO_PUBLIC_GOOGLE_PARTNER_FORM.trim()
      : '';
  if (fromExpo && fromExpo !== 'undefined') {
    return fromExpo;
  }
  // Plain `GOOGLE_PARTNER_FORM` build variable (e.g. Cloudflare Pages), inlined
  // by webpack DefinePlugin. Needed because `@env` only reads a local `.env`
  // file and does not see process.env on CI.
  const fromProcess =
    typeof process.env.GOOGLE_PARTNER_FORM === 'string'
      ? process.env.GOOGLE_PARTNER_FORM.trim()
      : '';
  if (fromProcess && fromProcess !== 'undefined') {
    return fromProcess;
  }
  return '';
}
